// Global Types
import type {
  $Children,
} from 'common.types';

// Global Components
import * as React from 'react';

// Helpers
import {
  Helmet,
} from 'react-helmet';
import {
  capitalize,
  getLocation,
} from '../../../helpers';
import config from '../../../config';

// Components
import Error from '../Error';
import Header from '../Header';
import Footer from '../Footer';
import Cookies from '../Cookies';

// Types
import type {
  $Tags,
} from '../../../types';

type $Props = {
  children: $Children;
  id: string;
  tags: $Tags;
};

const PageView = function ({
  children,
  id,
  tags,
}: $Props) {
  const title: string = capitalize(config.DOMAIN);

  return (
    <div
      className={'Page h-full'}
      id={id}
    >
      <Header />
      <Helmet>
        <title>
          {`${title} | ${tags.title}`}
        </title>
        <meta
          content={tags.url || getLocation().url}
          property={'og:url'}
        />
        <meta
          content={`${title} | ${tags.title}`}
          property={'og:title'}
        />
        {tags.description && (
          <meta
            content={tags.description}
            property={'og:description'}
          />
        )}
        <meta
          content={tags.image || `${config.CDN_URL}/static/logo-fb.png`}
          property={'og:image'}
        />
        <meta
          content={config.AUTH_FACEBOOK_APP_ID}
          property={'fb:app_id'}
        />
      </Helmet>
      <main
        className={'workspace max-w-screen-2xl mx-auto h-full flex flex-col px-2 sm:px-10'}
        id={'Content'}
      >
        <Error />
        <div className={'flex-grow'}>
          {children}
        </div>
        <div>
          <Footer />
          <Cookies />
        </div>
      </main>
      <div className={'tailwind bg-gray-50 text-opacity-25 top-2 bottom-2 right-2 left-2'} />
    </div>
  );
};

export default PageView;
